export default {
    PAGE_VIEW_TRIGGER: 'PAGE_VIEW_TRIGGER',
    DOMAIN_BASED_TIMED_TRIGGER: 'DOMAIN_BASED_TIMED_TRIGGER',
    DOM_CONTENT_LOADED_TRIGGER: 'DOM_CONTENT_LOADED_TRIGGER',
    ELEMENT_CLICK_TRIGGER: 'ELEMENT_CLICK_TRIGGER',
    OBSERVER_TRIGGER: 'OBSERVER_TRIGGER',
};
